import React from 'react'
import CMS from '../../components/cms/CMS'

const AccountPage = () => {
    return (
        <CMS>

        </CMS>
    )
}

export default AccountPage
